import * as React from 'react';
import { Select } from 'antd';

import InputControlProps from '../InputControlProps';

export interface SelectDropdownState {}

export class SelectDropdown extends React.Component<
  InputControlProps,
  SelectDropdownState
> {
  renderOptions = () => {
    let availableValues = this.props.availableValues;

    let options = [];
    for (let key in availableValues) {
      let value = availableValues[key];

      options.push(
        <Select.Option key={key} value={value}>
          {value}
        </Select.Option>,
      );
    }
    return options;
  };

  render() {
    const { placeholder, disabled, value, onChange } = this.props;
    return (
      <Select
        style={{ width: '100%', minWidth: 200 }}
        onChange={onChange}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        allowClear
        showSearch
      >
        {this.renderOptions()}
      </Select>
    );
  }
}

export default SelectDropdown;
